<template>
  <section v-if="hasPrimaryFeatures" qaid="product-primary-features" :class="[wrapperClass]">
    <h2 class="sr-only">{{ $t('text.productFeatures') }}</h2>
    <primary-feature
      v-for="(primaryFeature, index) in primaryFeatures"
      :key="`primary-feature-${index}`"
      :primary-feature="primaryFeature"
    />
  </section>
</template>

<script>
import {mapState} from 'vuex';
import PrimaryFeature from '@/components/tabs/features/PrimaryFeature.vue';

export default {
  components: {
    PrimaryFeature,
  },
  props: {
    wrapperClass: {
      type: String,
      default: 'mx-auto px-2 max-w-screen-xxl mt-4 mb-8',
    },
  },
  computed: {
    ...mapState('productDetails', ['product']),

    primaryFeatures() {
      return this.product?.productPrimaryFeatures;
    },
    hasPrimaryFeatures() {
      return !!this.primaryFeatures?.length;
    },
  },
};
</script>
